/**
 * Common JavaScript - Loaded on all pages
 * Contains jQuery, Bootstrap, and essential functionality
 *
 * This file is intentionally kept small (~85KB) as it loads on every page
 */

// jQuery and Bootstrap are loaded via script tags (they're large and already minified)
// This file contains only the essential common functionality

// Smooth scroll polyfill loading
(function() {
  'use strict';

  // Basic navigation functionality
  window.MolloyCommon = {
    init: function() {
      this.setupNavigation();
      this.setupForms();
      this.setupServiceWorker();
    },

    setupNavigation: function() {
      // Handle mobile menu
      const navbarToggler = document.querySelector('.navbar-toggler');
      if (navbarToggler) {
        navbarToggler.addEventListener('click', function() {
          document.body.classList.toggle('nav-open');
        });
      }

      // Close mobile menu on link click
      document.querySelectorAll('.navbar-nav .nav-link').forEach(link => {
        link.addEventListener('click', function() {
          const navbarCollapse = document.querySelector('.navbar-collapse');
          if (navbarCollapse && navbarCollapse.classList.contains('show')) {
            document.querySelector('.navbar-toggler')?.click();
          }
        });
      });
    },

    setupForms: function() {
      // Basic form validation
      const forms = document.querySelectorAll('.needs-validation');
      forms.forEach(form => {
        form.addEventListener('submit', function(event) {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }
          form.classList.add('was-validated');
        }, false);
      });

      // Contact form select placeholder styling
      const selects = document.querySelectorAll('select:required');
      selects.forEach(select => {
        select.addEventListener('change', function() {
          this.classList.toggle('placeholder-active', this.value === '');
        });
      });
    },

    setupServiceWorker: function() {
      // Service worker registration
      if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
          navigator.serviceWorker.register('/sw.js').catch(() => {});
        });
      }
    },

    // Utility: Load script dynamically
    loadScript: function(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },

    // Utility: Check if element is in viewport
    isInViewport: function(element) {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.MolloyCommon.init());
  } else {
    window.MolloyCommon.init();
  }
})();
